import { Injectable, inject } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { VehicleTripTypeSetupDto } from '@pages/vehicles-page/components/vehicle-tabs/vehicle-trip-type-setup-tab/interfaces';
import { Entity } from '@shared/constants/entity';
import { VehiclesTabsService } from './vehicles-tabs.service';
import { RestApiService } from '@core/services/rest-api.service';
import { VehicleDto } from '@pages/vehicles-page/components/vehicles-grid/interfaces';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { VehicleType } from '@shared/constants/vehicle-type';

@Injectable({ providedIn: 'root' })
export class SetupTabsSharedService {
  private vehicleInfoService = inject(VehiclesTabsService);
  private api = inject(RestApiService);
  private oidc = inject(OidcSecurityService);

  getTabData(
    entityId: string
  ): Observable<
    [
      VehicleTripTypeSetupDto,
      Pick<VehicleDto, 'VehicleTypeDescription' | 'Username' | 'ShowRecord'>,
    ]
  > {
    return combineLatest([
      this.api.getInfo<VehicleTripTypeSetupDto>(
        Entity.VehicleTripSetting,
        entityId,
        [
          'TimeInterval',
          'Holidays',
          'VehicleIntervalSetting',
          'VehicleType',
          'TripDepartmentFromUser',
          'FerryDeals',
        ]
      ),
      this.vehicleInfoService.getExtraVehicleData(entityId),
    ]);
  }

  isCurrentUsersPersonalVehicle(
    vehicleData: Partial<VehicleDto>
  ): Observable<boolean> {
    return this.oidc
      .getUserData()
      .pipe(
        map(
          ({ email }) =>
            vehicleData.VehicleTypeDescription === VehicleType.Personal &&
            email.toLowerCase() === vehicleData.Username?.toLowerCase()
        )
      );
  }

  saveVehicleSetup(
    entityId: string,
    data: Partial<VehicleTripTypeSetupDto>
  ): Observable<number | undefined> {
    return this.api.upsert(Entity.VehicleTripSetting, entityId, data);
  }
}
